export const fileUploadS3TestValue =
  "https://s3.console.aws.amazon.com/s3/object/afterpay-merchant-portal-dev?region=us-west-2&prefix=United Kingdom/a4E1s000000UJd5EAG_a/Assets/gerad-degas-govId_86c97577-c.heic";
